import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66df0ab4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ACarregamentoCalendario"
}
const _hoisted_2 = { class: "ACarregamentoSobreposto__Texto" }

import BlockUI from "primevue/blockui"
  import ProgressSpinner from "primevue/progressspinner"
  import { useI18n } from "vue-i18n"

  interface Props {
    estaCarregandoCalendario : boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ACarregamentoCalendario',
  props: {
    estaCarregandoCalendario: { type: Boolean }
  },
  setup(__props: any) {

  

  const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BlockUI), { blocked: __props.estaCarregandoCalendario }, {
    default: _withCtx(() => [
      (__props.estaCarregandoCalendario)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(ProgressSpinner), {
              "aria-label": "Suas atividades estão sendo carregadas",
              class: "ACarregamentoCalendario__Spinner",
              "stroke-width": "4"
            }),
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)('suasAtividadesEstaoSendoCarregadas')), 1)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["blocked"]))
}
}

})